export enum HangupCause {
    UNSPECIFIED = 'UNSPECIFIED',
    NO_ANSWER = 'NO_ANSWER',
    NORMAL_CLEARING = 'NORMAL_CLEARING',
    ORIGINATOR_CANCEL = 'ORIGINATOR_CANCEL',
    SERVICE_UNAVAILABLE = 'SERVICE_UNAVAILABLE',
    NO_USER_RESPONSE = 'NO_USER_RESPONSE',
}
